import { useEffect, useMemo, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Modal } from './Modal'
import { HeaderModal } from './Header'
import { Body } from './Body'
import { FooterModal } from './Footer'
import closeIcon from 'assets/images/close-icon.svg';
import modalBgShade from "../../../assets/images/bg-modal-shade.svg";
import allImgPaths from 'assets/images';
import CustomCheckBox from 'components/CustomCheckBox';
import { fileUploadList, getAttendeeList, resendEmails, sendEmails } from 'services/event';
import { cloneDeep } from 'lodash';
import { ExistingSettingMemberLoader } from 'components/loaders';
import CustomDropdown from '../dropdown/Dropdown';
import CustomSelect from '../CustomSelect';
import { format } from 'date-fns';
import Toast from '../Toast';
import { InputTextField } from 'components/InputField';

const pageOptions = [
    10, 50, 100, 500, 1000
]

const initStatusFilters = [
    { label: 'Invitation not sent', value: 'no', field: 'lastStatus' },
    { label: 'Invitation sent', value: 'sent', field: 'lastStatus' },
    { label: 'Invitation failed', value: 'failed', field: 'lastStatus' },
    { label: 'RSVP yes', value: '', field: '' },
    { label: 'RSVP no', value: '', field: '' },
    { label: 'RSVP maybe', value: '', field: '' },
    { label: 'RSVP awaiting', value: '', field: '' }
]

const AttendeeListModal = ({ data: templateData, ids, setShowListModal, type, categoryData }: any) => {
    const { id: eventId } = useParams();
    const [data, setData] = useState<any>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [allSelected, setAllSelected] = useState(false)
    const [searchText, setSearchText] = useState('');
    const [perPage, setPerPage] = useState(10)
    const [totalData, setTotalData] = useState(0)
    const [finalPage, setFinalPage] = useState(0)
    const [currentPage, setCurrentPage] = useState(1)
    const [totalEmailSent, setTotalEmailSent] = useState(0)
    const [showDismissBox, setShowDismissBox] = useState(false);
    const [isFocused, setIsFocused] = useState<boolean>(false);
    const [initListPayload, setInitListPayload] = useState<any>({
        event_id: ids.eventId,
        rag_id: ids?.ragId,
        ...categoryData,
        perPage: perPage,
        page: 1
    })
    const [originalData, setOriginalData] = useState<any>([])

    const [optionsSelected, setOptionsSelected] = useState(null)
    const [currentSort, setCurrentSort] = useState(0)
    const [btnDisabled, setBtnDisabled] = useState(true);

    const optionsList = [
        { value: 'yes', label: 'Yes, already included.' },
        { value: 'no_other', label: 'No, I want other vendors for that.' },
        { value: 'no_missed', label: 'No, I missed. Can we include now?' }
    ]
    const [sortOrder, setSortOrder] = useState('asc');
    const [selectedOption, setSelectedOption] = useState('')
    const [templateFiles, setTemplateFiles] = useState<any>([]);

    const [allFileList, setAllFileList] = useState<any>([]);
    const [selectedFiles, setSelectedFiles] = useState<any>([]);
    const [allFileSelected, setAllFileSelected] = useState(false);
    const [showFilesData, setShowFilesData] = useState(false);
    const [allStatusList, setAllStatusList] = useState<any>([]);
    const [selectedFilter, setSelectedFilter] = useState<any>(null);
    const [sortField, setSortField] = useState<any>(null);
    const [filterShow, setFilterShow] = useState<any>(false);
    const [invitationShow, setInvitationShow] = useState<any>(true);
    const [rsvpShow, setRsvpShow] = useState<any>(false);

    const handleFocus = () => {
        setIsFocused(true);
    };

    const handleBlur = () => {
        setIsFocused(false);
    };

    const handleInput = (e: any) => {
        if (!e.target.value) {
            setSearchText('');
            handleSearch(e, true)
        }
    }

    useEffect(() => {
        getAllFileList()
    }, [])

    // When multiple files are selected from list, and then fetch their attendees list
    // useEffect(() => {
    //     if (showFilesData) {
    //         setFilePayload(selectedFiles)
    //     }
    // }, [showFilesData])

    useEffect(() => {
        if (selectedFiles?.length > 0) {
            setFilePayload(selectedFiles)
        }
    }, [selectedFiles])

    // Fetch all the file list uniquely
    const getAllFileList = async () => {
        const { data } = await fileUploadList({ event_id: eventId, from_board: true })
        if (data?.length) {
            // data.map((dt: any) => {
            //     dt['selected'] = false;
            // });

            let allFilesListOptions: any = []
            data.map((dt: any) => {
                allFilesListOptions.push({
                    id: dt.file_name,
                    label: dt?.original_file_name || dt?.file_name,
                    value: dt.file_name
                })
            })

            console.log({ fileList: data })
            // setAllFileList(data)
            setAllFileList(allFilesListOptions)
        } else {
            setAllFileList([])
        }
    }

    const setFilePayload = (files: any[]) => {
        const updatedListPayload = cloneDeep(initListPayload);
        updatedListPayload['file_name'] = files;
        delete updatedListPayload?.filters;

        setInitListPayload(updatedListPayload)
        fetchList(updatedListPayload)
    }

    const fetchList = async (attendeePayload: any) => {
        setLoading(true)

        // console.log({ attendeePayload })

        try {
            const { data } = await getAttendeeList(attendeePayload)
            const updatedData = setListData(data?.data)
            // console.log({ updatedData })
            setTotalData(data?.length)
            setCurrentPage(attendeePayload.page)
            setFinalPage(Math.ceil(data?.length / attendeePayload.perPage))
            console.log({ attendeeData: updatedData })
            setData(updatedData)
            setOriginalData(cloneDeep(updatedData))
            setLoading(false)
        } catch (error) {
            setLoading(false)
            setListData([])
        }
    }

    const setListData = (data: any[]) => {
        if (data?.length) {
            let totalSent = 0
            data.map((dt: any) => {
                let count = 0
                const currentTemplateStatus = (dt?.emailStatus || []).find((es: any) => JSON.stringify(es?.ragId) == JSON.stringify(ids?.ragId)) || null;
                if (currentTemplateStatus) {
                    // totalSent = totalSent + currentTemplateStatus?.timeline?.length;
                    count = currentTemplateStatus?.timeline?.length
                    if (currentTemplateStatus?.timeline?.length > 0) {
                        let lastTimeLine = currentTemplateStatus.timeline[0];
                        dt['all_data']['lastStatus'] = lastTimeLine?.status || 'no'
                        dt['all_data']['sentTime'] = lastTimeLine?.sentTime || null
                    }
                } else {
                    dt['all_data']['lastStatus'] = 'no'
                    dt['all_data']['sentTime'] = null
                }

                totalSent = totalSent + (count == 0 ? 0 : 1)  // To have unique sent count

                dt['selected'] = false
                dt['count'] = count  // For total sent count of individual email
            });

            if (totalSent > 0) setShowDismissBox(true)
            setTotalEmailSent(totalSent)

            return data
        }
        return []
    }

    const handleSelection = (id: string, isChecked: boolean) => {
        let clonedData: any[] = cloneDeep(data);
        if (id != 'all') {
            const index = clonedData.findIndex((cd: any) => JSON.stringify(cd._id) == JSON.stringify(id));
            if (index > -1) {
                clonedData[index]['selected'] = isChecked;
            }

            // Set top checkbox status
            if (!isChecked) setAllSelected(false)

            const allSelected = clonedData.every((cd: any) => cd.selected);
            if (allSelected) setAllSelected(true)

        } else {
            clonedData = clonedData.map((cd: any) => ({ ...cd, selected: isChecked }))
            setAllSelected(isChecked)
        }

        setData(clonedData);

        if (clonedData.some((cd: any) => cd.selected)) {
            setBtnDisabled(false)
        } else {
            setBtnDisabled(true)
        }
    }

    const handleSearch = async (e: any, fromClose = false) => {
        e.preventDefault()
        const text = fromClose ? '' : (searchText ? searchText.trim() : '');
        const clonedAttendeePayload: any = cloneDeep(initListPayload);
        clonedAttendeePayload['query'] = text;
        setInitListPayload(clonedAttendeePayload)
        await fetchList(clonedAttendeePayload)
    }

    const handlePageChange = async (page: number) => {
        if (page > 0) {
            const clonedAttendeePayload: any = cloneDeep(initListPayload);
            clonedAttendeePayload['page'] = page;

            setInitListPayload(clonedAttendeePayload)
            await fetchList(clonedAttendeePayload)
        }
    }

    const [arrowUp, setArrowUp] = useState(false);
    const handleSort = (type: string) => {
        const sortedData = [...data].sort((a, b) => {
            if (type == 'sentTime') {
                const dateA: any = new Date(a.sentTime);
                const dateB: any = new Date(b.sentTime);
                if (sortOrder === 'asc') {
                    return dateA - dateB;
                } else {
                    return dateB - dateA;
                }
            } else {
                if (sortOrder === 'asc') {
                    return a['all_data'][type].localeCompare(b['all_data'][type]);
                } else {
                    return b['all_data'][type].localeCompare(a['all_data'][type]);
                }
            }
        });
        setData(sortedData);
        setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');

        setArrowUp(!arrowUp);
        setSortField(type);
    };

    const handlePerPageChange = async (e: any) => {
        const value = +e.target.value;
        if (value != perPage) {
            const clonedAttendeePayload: any = cloneDeep(initListPayload);
            clonedAttendeePayload['perPage'] = value;
            clonedAttendeePayload['page'] = 1;
            setInitListPayload(clonedAttendeePayload)
            await fetchList(clonedAttendeePayload);

            setPerPage(value)
        }
    }

    const send = async () => {
        const { eventId, ragId } = ids;
        const receivers = data.filter((dt: any) => dt?.selected).map((dt: any) => dt?._id);

        if (receivers?.length > 0) {
            const payload = { ragId, receivers, ...categoryData }

            await resendEmails(eventId, payload)
            setShowListModal(false)

            Toast.success('Email', 'Emails sent successfully')
        }
    }

    const handleFileListSelection = (filename: string, isChecked: boolean) => {
        console.log({ filename, isChecked })
        let clonedData: any[] = cloneDeep(allFileList);
        if (filename != 'all') {
            const index = clonedData.findIndex((cd: any) => JSON.stringify(cd.file_name) == JSON.stringify(filename));
            if (index > -1) {
                clonedData[index]['selected'] = isChecked;
            }

            // Set top checkbox status
            if (!isChecked) setAllFileSelected(false)

            const allSelected = clonedData.every((cd: any) => cd.selected);
            if (allSelected) setAllFileSelected(true)

        } else {
            clonedData = clonedData.map((cd: any) => ({ ...cd, selected: isChecked }))
            setAllFileSelected(isChecked)
        }

        setAllFileList(clonedData);

        const selectedFiles = clonedData.filter((cd: any) => cd.selected).map((cd: any) => cd.file_name);
        setSelectedFiles(selectedFiles)
        console.log({ selectedFiles })
    }

    const handleFileListChange = (data: any) => {
        setSelectedFiles([data.value])
        setShowFilesData(true)
        setSelectedFilter(null)
    }

    // const handleFilterChange = async (dataObj: any) => {
    //     if (!dataObj.value) return
    //     setSelectedFilter(dataObj)
    //     const statusValue = dataObj.value;
    //     const clonedAttendeePayload: any = cloneDeep(initListPayload);
    //     clonedAttendeePayload['filters'] = {
    //         status: statusValue
    //     }
    //     setInitListPayload(clonedAttendeePayload)
    //     await fetchList(clonedAttendeePayload)
    // }

    const clearFilters = async () => {
        const clonedAttendeePayload: any = cloneDeep(initListPayload);
        if (clonedAttendeePayload?.filters) {
            setFilterShow(false)
            setInvitationShow(false)
            setRsvpShow(false)

            setSelectedFilter(null)
            delete clonedAttendeePayload?.['filters']
            setInitListPayload(clonedAttendeePayload)
            await fetchList(clonedAttendeePayload)
        }
    }

    const handleFilterChange = async (value: any) => {
        if (!value) return
        const statusValue = value;
        const clonedAttendeePayload: any = cloneDeep(initListPayload);
        clonedAttendeePayload['filters'] = {
            status: statusValue
        }
        setFilterShow(false)
        setInitListPayload(clonedAttendeePayload)
        await fetchList(clonedAttendeePayload)
    }

    const handleRSVPFilterChange = async (value: any) => {
        if (!value) return
        const statusValue = value;
        const clonedAttendeePayload: any = cloneDeep(initListPayload);
        clonedAttendeePayload['filters'] = {
            rsvp_status: statusValue
        }
        setFilterShow(false)
        setInitListPayload(clonedAttendeePayload)
        await fetchList(clonedAttendeePayload)
    }

    return (
        <div>
            <Modal className={"modal-wrapper max-w-[1440px]"} isShow={setShowListModal}>
                <div>
                    <HeaderModal title={''} isShowHeader={true} className="modal-header">
                        <div className="flex items-center justify-between py-4 px-4 border-b border-[#EAECF0]">
                            <div className="flex items-center gap-x-2">
                                <img src={allImgPaths.sendIcon4} alt="" />
                                <h2 className="text-xl text-[#101828] font-interSemiBold leading-none">Send to</h2>
                            </div>
                            {/* Close Icon */}
                            <img
                                className="modal-close modal-toggle cursor-pointer hover:bg-[#f2f4f7] rounded w-5 p-1 mr-4"
                                id="modal-toggle"
                                src={closeIcon}
                                onClick={() => { setShowListModal(false) }}
                                alt="close icon"
                            />
                        </div>
                    </HeaderModal>

                    <Body title="" isShowBody={true} className="modal-body px-6 flex gap-x-4 max-h-[calc(100vh_-_250px)] pt-7">
                        <div className="bg-[#F9FAFB] py-4 px-2 w-[326px]">
                            {/* Dismiss Box */}
                            {
                                showDismissBox &&
                                <div className="mb-5 border border-[#D0D5DD] rounded-xl py-4 px-4 bg-white shadow-sm flex flex-shrink-0 items-start gap-x-2.5">

                                    <img src={allImgPaths.alertIconSaffron} alt="" />

                                    <div className="">
                                        <p className='text-sm font-interMedium text-[#344054] pb-1'>Just to let you know you have already sent out this invitation earlier</p>
                                        <p className='text-sm text-[#475467] pb-2'>
                                            {/* You have sent out this email invitation to 100 attendees on May 31, 2024 */}
                                            You have sent out this email invitation to {totalEmailSent} attendees
                                        </p>
                                        <button
                                            className='text-[#475467] text-sm font-interMedium'
                                            onClick={() => setShowDismissBox(false)}>
                                            Dismiss
                                        </button>
                                    </div>

                                </div>
                            }

                            {/* card will render here.. */}
                            {
                                <div className="">
                                    <div className='border border-[#EAECF0] px-2 py-2 rounded-[10px] bg-[#fff] w-[280px] flex-shrink-0 hover:shadow-xl'>
                                        <div className="relative">

                                            <div className="rounded-tl-lg rounded-tr-lg border border-dashed border-[#EAECF0] pl-4 pt-1">
                                                <h5 className="text-lg text-[#344054] truncate max-w-52 font-interMedium">
                                                    {templateData?.pinData?.title || 'No Title'}
                                                </h5>
                                                <h6 className="text-sm text-[#344054] pb-2 truncate max-w-52">
                                                    {templateData?.pinData?.selectedOption || 'No Subheading'}
                                                </h6>
                                            </div>
                                            <div className='h-[190px] rounded-[10px] mb-2.5 group'>
                                                <div className='flex items-center justify-between'>
                                                    {
                                                        totalEmailSent > 0 &&
                                                        <div className={`items-center gap-x-1.5 bg-[#ecfcf3] py-5.5 px-3 mt-12 rounded-lg text-[#3f7f52] absolute top-2 right-2 cursor-pointer w-fit`}>
                                                            <span>Sent to {totalEmailSent} attendees</span>
                                                        </div>
                                                    }

                                                    <img
                                                        className={`rounded-bl-[10px] rounded-br-[10px] w-full h-full object-cover mb-2`}
                                                        src={data?.imageUrl ? data.imageUrl : allImgPaths.EmailTemplateImage}
                                                        alt=''
                                                    />
                                                </div>
                                            </div>
                                            <h5 title={data?.title} className={`mt-4 text-[#101828] font-interSemiBold text-[17px] line-clamp-2 max-w-72 px-0.5 mb-2 h-12`}>
                                                {templateData?.title || 'No title'}
                                            </h5>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>

                        <div className="flex-1">
                            <div className='w-96'>
                                {
                                    allFileList && allFileList?.length > 0 &&
                                    <>
                                        <p className='text-base font-interSemiBold text-[#101828] mb-2'>Select file</p>
                                        <div className='modal-select-box fete-settings-modals'>
                                            <CustomSelect
                                                onChange={handleFileListChange}
                                                options={allFileList}
                                            />
                                        </div>
                                    </>
                                }
                            </div>

                            <div className='w-full'>
                                {
                                    showFilesData &&
                                    <>
                                        <div className="flex items-center gap-x-2 mb-6 mt-5">
                                            <span className='text-base font-interSemiBold text-[#101828]'>Attendess List</span>
                                            <span className='bg-[#e8e6fe] border border-[#958de3] rounded px-2 py-0.5 inline-block text-sm text-[#1E0AF5] font-interSemiBold'>
                                                {totalData}
                                            </span>
                                        </div>
                                        <div className='flex items-center mt-5 justify-between w-[1078px] mb-6'>

                                            <form onSubmit={(e: any) => handleSearch(e, false)} className="flex items-center">
                                                <div className={`border rounded-lg w-80 py-2 px-3.5 flex items-center gap-x-2 hover:border-[#1E0AF5] ${isFocused ? "border-[#1e0af5]" : "border-[#D0D5DD]"}`}>
                                                    <img src={allImgPaths.searchIcon} alt="search" />
                                                    <input
                                                        className="w-full"
                                                        placeholder="Search by Name or Email"
                                                        type="text"
                                                        onChange={(e) => setSearchText(e.target.value)}
                                                        value={searchText}
                                                        onFocus={handleFocus}
                                                        onBlur={handleBlur}
                                                        onInput={handleInput}
                                                    />
                                                    {
                                                        searchText &&
                                                        <img
                                                            className='cursor-pointer'
                                                            src={allImgPaths.closeIconRed}
                                                            alt=""
                                                            onClick={(e) => {
                                                                setSearchText('');
                                                                handleSearch(e, true)
                                                            }}
                                                        />
                                                    }
                                                </div>

                                                <button
                                                    type='submit'
                                                    className={`submit-btn-blue !px-[15px] ml-5 !text-sm hover:bg-[#120693] ${searchText ? '' : 'button-disabled'}`}
                                                    // onClick={() => handleSearch(false)}
                                                    disabled={searchText ? false : true}
                                                >
                                                    Search
                                                </button>
                                            </form>
                                            {/* </div> */}
                                            <div className='flex gap-x-3 items-center'>
                                                {/* <div className='w-80'>
                                                    <div className='modal-select-box fete-settings-modals'>
                                                        <CustomSelect
                                                            onChange={handleFilterChange}
                                                            options={initStatusFilters}
                                                            selectedValue={selectedFilter}
                                                            className='!mb-0'
                                                            placeholder='Filter by'
                                                        />
                                                    </div>
                                                </div>
                                                {
                                                    selectedFilter &&
                                                    <button className='cancle-btn-blue hover:border-[#1E0AF5] !px-[15px] !text-sm' onClick={clearFilters}>Clear</button>
                                                } */}
                                                <div className="relative">
                                                    <div onClick={() => setFilterShow(!filterShow)} className={`flex items-center justify-between gap-x-2 border hover:border-[#1e0af5] rounded-lg tracking-wide px-3.5 py-2 cursor-pointer ${filterShow ? "border-[#1e0af5]" : "border-[#D0D5DD]"}`}>
                                                        <img
                                                            src={allImgPaths.filterIcon}
                                                            alt=""
                                                        />
                                                        <span className="text-[#344054] font-interSemiBold">Filters</span>
                                                    </div>
                                                    <div className={`absolute top-full right-0 border border-[#E4E7EC] rounded-lg shadow-customShadow z-10 bg-white w-72 ${filterShow ? "block" : "hidden"}`}>
                                                        {/* <p className='text-[#667085] font-interSemiBold px-3 pt-2 pb-2'>Filters</p> */}
                                                        <div className="relative flex">
                                                            <div className="w-1/2">
                                                                <p
                                                                    onClick={() => {
                                                                        setInvitationShow(!invitationShow);
                                                                        setRsvpShow(false);
                                                                    }}
                                                                    className={`text-sm px-3 py-2 hover:text-[#1E0AF5] cursor-pointer font-interMedium ${invitationShow ? "bg-[#E8E6FE] text-[#1E0AF5]" : "text-[#667085]"}`}>Invitation Sent
                                                                </p>

                                                                <p
                                                                    onClick={() => {
                                                                        setRsvpShow(!rsvpShow);
                                                                        setInvitationShow(false);
                                                                    }}
                                                                    className={`text-sm px-3 py-2 hover:text-[#1E0AF5] cursor-pointer font-interMedium ${rsvpShow ? "bg-[#E8E6FE] text-[#1E0AF5]" : "text-[#667085]"}`}>RSVP Status</p>
                                                            </div>

                                                            <div className={`w-1/2 border-l border-[#E4E7EC] bg-white ${invitationShow ? "block" : "hidden"}`}>
                                                                <p
                                                                    onClick={() => handleFilterChange('sent')} className='text-sm text-[#667085] px-3 py-2 hover:text-[#1E0AF5] cursor-pointer font-interMedium'>
                                                                    Sent
                                                                </p>
                                                                <p
                                                                    onClick={() => handleFilterChange('no')} className='text-sm text-[#667085] px-3 py-2 hover:text-[#1E0AF5] cursor-pointer font-interMedium'>
                                                                    Not sent
                                                                </p>
                                                                <p
                                                                    onClick={() => handleFilterChange('failed')} className='text-sm text-[#667085] px-3 py-2 hover:text-[#1E0AF5] cursor-pointer font-interMedium'>
                                                                    Failed
                                                                </p>
                                                            </div>

                                                            <div className={`w-1/2 border border-[#E4E7EC] bg-white ${rsvpShow ? "block" : "hidden"}`}>
                                                                <p onClick={() => handleRSVPFilterChange('yes')} className='text-sm text-[#667085] px-3 py-2 hover:text-[#1E0AF5] cursor-pointer font-interMedium'>Yes</p>
                                                                <p onClick={() => handleRSVPFilterChange('no')} className='text-sm text-[#667085] px-3 py-2 hover:text-[#1E0AF5] cursor-pointer font-interMedium'>No</p>
                                                                <p onClick={() => handleRSVPFilterChange('maybe')} className='text-sm text-[#667085] px-3 py-2 hover:text-[#1E0AF5] cursor-pointer font-interMedium'>Maybe</p>
                                                            </div>

                                                        </div>

                                                        {/* <div className="relative">
                                                            <p
                                                                onClick={clearFilters}
                                                                className='text-sm text-[#667085] px-3 py-2 hover:text-[#1E0AF5] ccursor-pointer font-interMedium hover:bg-[#E8E6FE] cursor-pointer'>Clear
                                                            </p>
                                                        </div> */}
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                        {loading && <ExistingSettingMemberLoader />}
                                        {
                                            !loading && data && data?.length > 0 &&
                                            <>
                                                <div className="overflow-x-auto w-[calc(100%_-_710px)]">
                                                    <div className="custom-table-grid-attendees-list-edit whitespace-nowrap">
                                                        <div className='flex gap-x-2 items-center py-2 px-2 border border-[#EAECF0] border-b-0 border-r-0 last:border-r checkbox-alignment'>
                                                            <CustomCheckBox
                                                                label={''}
                                                                name={'all'}
                                                                checked={allSelected}
                                                                onChange={handleSelection}
                                                            />
                                                        </div>

                                                        <div className='flex items-center min-w-[220px] bg-[#F9FAFB] border border-[#EAECF0] border-b-0 border-r-0 last:border-r'>
                                                            <span className="font-interMedium text-sm text-[#475467] py-3 px-2 capitalize checkbox-alignment flex gap-x-2 items-center">
                                                                First Name
                                                                <span className='on-hover-bg-blue rounded p-0.5' onClick={() => handleSort('first name')}>
                                                                    {/* <img className={`w-4 cursor-pointer transform ${arrowUp ? "rotate-0" : "rotate-180"}`} src={allImgPaths.arrowUp3} alt="" /> */}
                                                                    <img
                                                                        className={`w-4 cursor-pointer transform ${(sortField === 'first name' && sortOrder == 'asc') ? "rotate-0" : "rotate-180"}`}
                                                                        src={allImgPaths.arrowUp3} alt=""
                                                                    />
                                                                </span>
                                                            </span>
                                                        </div>

                                                        <div className='flex items-center min-w-[220px] bg-[#F9FAFB] border border-[#EAECF0] border-b-0 border-r-0 last:border-r'>
                                                            <span className="font-interMedium text-sm text-[#475467] py-3 px-2 capitalize checkbox-alignment flex gap-x-2 items-center">
                                                                Last Name
                                                                <span className='on-hover-bg-blue rounded p-0.5' onClick={() => handleSort('last name')}>
                                                                    {/* <img className={`w-4 cursor-pointer transform ${arrowUp ? "rotate-0" : "rotate-180"}`} src={allImgPaths.arrowUp3} alt="" /> */}
                                                                    <img
                                                                        className={`w-4 cursor-pointer transform ${(sortField === 'last name' && sortOrder == 'asc') ? "rotate-0" : "rotate-180"}`}
                                                                        src={allImgPaths.arrowUp3} alt=""
                                                                    />
                                                                </span>
                                                            </span>
                                                        </div>

                                                        <div className='flex items-center min-w-[220px] bg-[#F9FAFB] border border-[#EAECF0] border-b-0 border-r-0 last:border-r'>
                                                            <span className="font-interMedium text-sm text-[#475467] py-3 px-2 capitalize flex gap-x-2 items-center">
                                                                Email
                                                                <span className='on-hover-bg-blue rounded p-0.5' onClick={() => handleSort('email')}>
                                                                    {/* <img className={`w-4 cursor-pointer transform ${arrowUp ? "rotate-0" : "rotate-180"}`} src={allImgPaths.arrowUp3} alt="" /> */}
                                                                    <img
                                                                        className={`w-4 cursor-pointer transform ${(sortField === 'email' && sortOrder == 'asc') ? "rotate-0" : "rotate-180"}`}
                                                                        src={allImgPaths.arrowUp3} alt=""
                                                                    />
                                                                </span>
                                                            </span>
                                                        </div>

                                                        <div className='flex items-center min-w-[220px] bg-[#F9FAFB] border border-[#EAECF0] border-b-0 border-r-0 last:border-r'>
                                                            <span className="font-interMedium text-sm text-[#475467] py-3 px-2 capitalize checkbox-alignment flex gap-x-2 items-center">
                                                                Total Sent
                                                            </span>
                                                        </div>

                                                        <div className='flex items-center min-w-[220px] bg-[#F9FAFB] border border-[#EAECF0] border-b-0 border-r-0 last:border-r'>
                                                            <span className="font-interMedium text-sm text-[#475467] py-3 px-2 capitalize checkbox-alignment flex gap-x-2 items-center">
                                                                Invitation Status
                                                            </span>
                                                        </div>

                                                        <div className='flex items-center min-w-[220px] bg-[#F9FAFB] border border-[#EAECF0] border-b-0 border-r-0 last:border-r'>
                                                            <span className="font-interMedium text-sm text-[#475467] py-3 px-2 capitalize checkbox-alignment flex gap-x-2 items-center">
                                                                Invitation Status Date
                                                            </span>
                                                        </div>

                                                        <div className='flex items-center min-w-[220px] bg-[#F9FAFB] border border-[#EAECF0] border-b-0 border-r-0 last:border-r'>
                                                            <span className="font-interMedium text-sm text-[#475467] py-3 px-2 capitalize checkbox-alignment flex gap-x-2 items-center">
                                                                RSVP Status
                                                            </span>
                                                        </div>

                                                        <div className='flex items-center min-w-[220px] bg-[#F9FAFB] border border-[#EAECF0] border-b-0 border-r-0 last:border-r rounded-tr-lg'>
                                                            <span className="font-interMedium text-sm text-[#475467] py-3 px-2 capitalize checkbox-alignment flex gap-x-2 items-center">
                                                                RSVP Status Date
                                                            </span>
                                                        </div>
                                                    </div>

                                                    <div className="max-h-[calc(100vh_-_600px)]">
                                                        {
                                                            data?.length > 0 && data.map((dt: any, index: number) => (
                                                                <div key={index} className="custom-table-grid-attendee-upload">
                                                                    <div className="flex gap-x-2 items-center py-2 px-2 border border-[#EAECF0] border-b-0 border-r-0 last:border-r checkbox-alignment">
                                                                        <CustomCheckBox
                                                                            label={''}
                                                                            name={dt._id}
                                                                            checked={dt.selected}
                                                                            onChange={handleSelection}
                                                                            customStyle=''
                                                                        />
                                                                    </div>
                                                                    <div className="min-w-[220px] flex items-center py-2 px-2 border border-[#EAECF0] border-b-0 border-r-0 last:border-r">
                                                                        <span className='whitespace-nowrap text-sm text-gray-900 truncate max-w-52'>
                                                                            {dt?.all_data?.['first name'] || 'No Name'}
                                                                        </span>
                                                                    </div>

                                                                    <div className="min-w-[220px] flex items-center py-2 px-2 border border-[#EAECF0] border-b-0 border-r-0 last:border-r">
                                                                        <span className='whitespace-nowrap text-sm text-gray-900 truncate max-w-52'>
                                                                            {dt?.all_data?.['last name'] || '-'}
                                                                        </span>
                                                                    </div>

                                                                    <div className="min-w-[220px] flex items-center py-2 px-2 border border-[#EAECF0] border-b-0 border-r-0 last:border-r">
                                                                        <span className='whitespace-nowrap text-sm text-gray-900 truncate max-w-52'>
                                                                            {dt?.all_data?.email || '-'}
                                                                        </span>
                                                                    </div>

                                                                    <div className="min-w-[220px] flex items-center py-2 px-2 border border-[#EAECF0] border-b-0 border-r-0 last:border-r">
                                                                        <span className='whitespace-nowrap text-sm text-gray-900 truncate max-w-52'>
                                                                            {dt?.count || '-'}
                                                                        </span>
                                                                    </div>

                                                                    <div className="min-w-[220px] flex items-center py-2 px-2 border border-[#EAECF0] border-b-0 border-r-0 last:border-r">
                                                                        {
                                                                            dt?.all_data?.lastStatus == 'no' &&
                                                                            <span className='whitespace-nowrap text-sm text-gray-900'>
                                                                                Not Sent
                                                                            </span>
                                                                        }
                                                                        {
                                                                            dt?.all_data?.lastStatus == 'sent' &&
                                                                            <span className='whitespace-nowrap text-sm text-gray-900'>
                                                                                Sent
                                                                            </span>
                                                                        }
                                                                        {
                                                                            dt?.all_data?.lastStatus == 'failed' &&
                                                                            <span className='whitespace-nowrap text-sm text-gray-900 '>
                                                                                Failed
                                                                            </span>
                                                                        }
                                                                    </div>
                                                                    <div className="min-w-[220px] flex items-center py-2 px-2 border border-[#EAECF0] border-b-0 border-r-0 last:border-r">
                                                                        <span className='whitespace-nowrap text-sm text-gray-900 truncate max-w-52'>
                                                                            {dt?.all_data?.sentTime ? format(dt?.all_data?.sentTime, 'MMM dd yyyy') : '-'}
                                                                        </span>
                                                                    </div>

                                                                    <div className="min-w-[220px] flex items-center py-2 px-2 border border-[#EAECF0] border-b-0 border-r-0 last:border-r">
                                                                        <span className='whitespace-nowrap text-sm text-gray-900 truncate max-w-52'>
                                                                            {'-'}
                                                                        </span>
                                                                    </div>

                                                                    <div className="min-w-[220px] flex items-center py-2 px-2 border border-[#EAECF0] border-b-0 border-r-0 last:border-r">
                                                                        <span className='whitespace-nowrap text-sm text-gray-900 truncate max-w-52'>
                                                                            {'-'}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            ))
                                                        }
                                                    </div>
                                                </div>
                                                {/* Pagination Box */}
                                                <div className="flex w-full items-center mt-3">
                                                    <div>
                                                        <select
                                                            value={perPage}
                                                            onChange={handlePerPageChange}
                                                            className='mr-5 border border-[#ccc] px-3 py-1.5 rounded-md' id="numberDropdown" name="numberDropdown">
                                                            {
                                                                pageOptions.map((po: any, index: number) => (
                                                                    <option value={po} key={index}>
                                                                        {po}
                                                                    </option>
                                                                ))
                                                            }
                                                        </select>
                                                    </div>

                                                    <div className="flex items-center gap-x-1">
                                                        <span className='text-sm text-[#344054] font-interMedium'>Page</span>
                                                        <span className='text-sm text-[#344054] font-interMedium'>{currentPage}</span>
                                                        <span className='text-sm text-[#344054] font-interMedium'>of</span>
                                                        <span className='text-sm text-[#344054] font-interMedium'>
                                                            {finalPage}
                                                        </span>
                                                    </div>
                                                    <div className="flex items-center gap-x-1.5">
                                                        {
                                                            (currentPage != 1 || currentPage == finalPage) && totalData > perPage &&
                                                            <img
                                                                className='cursor-pointer'
                                                                src={allImgPaths.pagiLeftBtn}
                                                                alt=""
                                                                onClick={() => handlePageChange(currentPage - 1)} />
                                                        }
                                                        {
                                                            currentPage != finalPage &&
                                                            <img
                                                                className='cursor-pointer'
                                                                src={allImgPaths.pagiRightBtn}
                                                                alt=""
                                                                onClick={() => handlePageChange(currentPage + 1)} />
                                                        }
                                                    </div>
                                                </div>
                                            </>
                                        }
                                        {
                                            !loading && !data?.length &&
                                            <div className='ml-3'>
                                                <h3>No Attendees Available</h3>
                                            </div>
                                        }
                                    </>
                                }

                                {
                                    !showFilesData &&
                                    <>
                                        <div className="w-full flex items-center justify-center pt-8">
                                            <img src={allImgPaths.selectFileEmptyState} alt="" />
                                        </div>
                                    </>
                                }
                            </div>
                        </div>
                    </Body>

                    <FooterModal title="" isShowFooter={true} className="modal-footer pb-6 px-6 pt-5">
                        <div className="flex justify-end gap-x-3">
                            <button
                                className='cancle-btn-blue hover:border-[#1E0AF5] !px-[15px] !text-sm'
                                onClick={() => { setShowListModal(false) }}>
                                Cancel
                            </button>

                            {
                                showFilesData &&
                                <button
                                    className={`submit-btn-blue !px-[15px] !text-sm ${btnDisabled ? 'button-disabled' : ''}`}
                                    onClick={send}
                                    disabled={btnDisabled}
                                >
                                    Send
                                </button>
                            }
                        </div>
                    </FooterModal>
                </div>
            </Modal >
        </div >
    )
}

export default AttendeeListModal